/**
 * @generated SignedSource<<f4dce962924effb0bd24481c8bf472ac>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpsertAnthropicIntegrationInput = {
  adminKey?: string | null | undefined;
  orgId: string;
};
export type UpsertAnthropicIntegrationMutation$variables = {
  connections: ReadonlyArray<string>;
  input: UpsertAnthropicIntegrationInput;
};
export type UpsertAnthropicIntegrationMutation$data = {
  readonly upsertAnthropicIntegration: {
    readonly anthropicIntegration: {
      readonly configured: boolean;
      readonly id: string;
      readonly orgId: string;
      readonly orgName: string | null | undefined;
    } | null | undefined;
    readonly problems: ReadonlyArray<{
      readonly __typename: string;
      readonly message: string;
    }>;
  };
};
export type UpsertAnthropicIntegrationMutation = {
  response: UpsertAnthropicIntegrationMutation$data;
  variables: UpsertAnthropicIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "AnthropicIntegration",
  "kind": "LinkedField",
  "name": "anthropicIntegration",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "configured",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "problems",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpsertAnthropicIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "UpsertAnthropicIntegrationPayload",
        "kind": "LinkedField",
        "name": "upsertAnthropicIntegration",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "UpsertAnthropicIntegrationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "UpsertAnthropicIntegrationPayload",
        "kind": "LinkedField",
        "name": "upsertAnthropicIntegration",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "anthropicIntegration",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "AnthropicIntegrationEdge"
              }
            ]
          },
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d124c5617b91dfa685c06a5ee1aadef2",
    "id": null,
    "metadata": {},
    "name": "UpsertAnthropicIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation UpsertAnthropicIntegrationMutation(\n  $input: UpsertAnthropicIntegrationInput!\n) {\n  upsertAnthropicIntegration(input: $input) {\n    anthropicIntegration {\n      configured\n      id\n      orgId\n      orgName\n    }\n    problems {\n      __typename\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "444bb316323a35dc082f677f4940ec6a";

export default node;
